import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import Tab from "./Tab";
import { ITabPanel } from "./TabPanel";

interface ITabListProps {
  centered?: boolean;
}

export const TabListShared = css`
  display: flex;
  align-items: center;
  padding: 0;
  border: ${({ theme }) => theme.borders[0]};
  border-radius: 8px;
  list-style-type: none;
  background-color: ${({ theme }) => theme.colors.white4};
`;

const TabList = styled.ul<ITabListProps>`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 2px;
  border: ${({ theme }) => theme.borders[0]};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white4};
  list-style-type: none;

  ${({ centered }) =>
    centered === true &&
    css`
      width: 70%;
      margin: 0 auto;

      @media (min-width: ${({ theme }) => theme.breakpoints[2]}) {
        width: 35%;
      }
    `}
`;

interface IProps {
  children: Array<React.ReactElement<ITabPanel>>;
  defaultSelected?: number;
  locationHash?: string;
  centered?: boolean;
}

const Tabs: React.FC<IProps> = ({
  centered = false,
  children,
  defaultSelected = 0,
  locationHash = "",
}) => {
  const [selected, setSelected] = useState(defaultSelected);

  useEffect(() => {
    let initialSelected = selected;
    if (locationHash) {
      React.Children.forEach(children, (child, index) => {
        const panel = child as React.ReactElement<ITabPanel>;
        if (`#${panel.props.link}` === locationHash) {
          initialSelected = index;
        }
      });
    }
    setSelected(initialSelected);
  }, [locationHash, selected, children]);

  const handleClick = (index: number) => {
    setSelected(index);
  };

  return (
    <>
      <TabList centered={centered}>
        {React.Children.map(children, (child, index) => {
          const panel = child as React.ReactElement<ITabPanel>;
          return (
            <Tab
              key={index}
              index={index}
              label={panel.props.label}
              link={panel.props.link}
              onClick={handleClick}
              selected={selected === index}
            />
          );
        })}
      </TabList>
      {children[selected]}
    </>
  );
};

export default Tabs;
